import { render, staticRenderFns } from "./OffCanvasSopimus.vue?vue&type=template&id=91ef6542&scoped=true&"
import script from "./OffCanvasSopimus.vue?vue&type=script&lang=js&"
export * from "./OffCanvasSopimus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ef6542",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91ef6542')) {
      api.createRecord('91ef6542', component.options)
    } else {
      api.reload('91ef6542', component.options)
    }
    module.hot.accept("./OffCanvasSopimus.vue?vue&type=template&id=91ef6542&scoped=true&", function () {
      api.rerender('91ef6542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasSopimus.vue"
export default component.exports